"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
exports.default = (function (props) {
    var isOpen = props.isOpen, handleClose = props.handleClose, modalHeader = props.modalHeader, modalText = props.modalText;
    return (React.createElement(modal_1.default, { handleClose: handleClose, isOpen: isOpen, style: { content: { borderRadius: '10px' } } },
        React.createElement("div", { className: 'padding-4 bg-white' },
            React.createElement("div", { className: 'text-center' },
                React.createElement("h4", { className: 'margin-vertical-4 medium-padding-horizontal-20' }, modalHeader),
                React.createElement("div", { className: 'divider bg-cornflower-blue margin-vertical-10', style: { width: '50px', margin: 'auto' } }),
                React.createElement("div", { className: 'margin-vertical-4 medium-padding-horizontal-20 text-gray' }, modalText)),
            React.createElement("div", { className: 'padding-top-3 text-center' },
                React.createElement("button", { className: 'bg-light-wisteria padding-5 text-white', onClick: function () { return handleClose(); } }, "Back to Free Diapers")))));
});
